import contrast from "contrast";

const foregroundColour = colour => (colour ? ((contrast(colour) === "light") ? "#000" : "#fff") : undefined);

export {foregroundColour};
